import http from "@/settings/apiSettings"

class COM_RaportVanzariService {
    getRaportAgenti(an: number, luna: number, tipDocumentId?: string): Promise<any> {
        const params = new URLSearchParams({ an: String(an), luna: String(luna) });
        if (tipDocumentId) params.append('tipDocumentId', tipDocumentId);
        return http.clientComercial.get(`/COM_RaportVanzari/GetRaportAgenti?${params}`);
    }

    getDetaliiAgent(agentId: string, an: number, luna: number, tipDocumentId?: string): Promise<any> {
        const params = new URLSearchParams({ agentId, an: String(an), luna: String(luna) });
        if (tipDocumentId) params.append('tipDocumentId', tipDocumentId);
        return http.clientComercial.get(`/COM_RaportVanzari/GetDetaliiAgent?${params}`);
    }
}

export default new COM_RaportVanzariService();
